import { render } from "./FormUpload.vue?vue&type=template&id=b035fbbc"
import script from "./FormUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./FormUpload.vue?vue&type=script&setup=true&lang=js"

import "./FormUpload.vue?vue&type=style&index=0&id=b035fbbc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Atoms/FormUpload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b035fbbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b035fbbc', __exports__)) {
    api.reload('b035fbbc', __exports__)
  }
  
  module.hot.accept("./FormUpload.vue?vue&type=template&id=b035fbbc", () => {
    api.rerender('b035fbbc', render)
  })

}


export default __exports__